var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPermissions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 8.33334V6.66667C15.0002 3.90525 12.7616 1.66667 10.0002 1.66667C7.23874 1.66667 5.00016 3.90525 5.00016 6.66667V8.33334C4.07969 8.33334 3.3335 9.07953 3.3335 10V16.6667C3.3335 17.5871 4.07969 18.3333 5.00016 18.3333H15.0002C15.9206 18.3333 16.6668 17.5871 16.6668 16.6667V10C16.6668 9.07953 15.9206 8.33334 15.0002 8.33334ZM6.66683 6.66667C6.66683 4.82572 8.15921 3.33334 10.0002 3.33334C11.8411 3.33334 13.3335 4.82572 13.3335 6.66667V8.33334H6.66683V6.66667ZM11.6668 14.1667C11.6668 14.6269 11.2937 15 10.8335 15H9.16683C8.70659 15 8.3335 14.6269 8.3335 14.1667V12.5C8.3335 12.0398 8.70659 11.6667 9.16683 11.6667H10.8335C11.2937 11.6667 11.6668 12.0398 11.6668 12.5V14.1667Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPermissions);
export default __webpack_public_path__ + "static/media/icon-permissions.2ebe159b.svg";
export { ForwardRef as ReactComponent };